import React, { useState} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axiosInstances from '../../components/axiosInstance';
import { Navigate } from "react-router-dom"; 


const PlayCreate = ()=>{
    const [amount, setAmount ] = useState('');
    const [totalAmount, setTotalAmount ] = useState('');
    const [no_of_tickets, setNoOfTickets ] = useState('');
    const [redirect, setRedirect] = useState(false);
    const submit = async (e)=>{
         e.preventDefault();
         const {data} = await axiosInstances.write.post('myDrawTickets', {
            of_bundle_amount:amount,
            of_ticket_bundle:no_of_tickets,
        });
        //console.log(typeof no_of_tickets);
        //console.log(data);
        if(data){
            //see how to handle response
        }
        setRedirect(true);
     }
     const manageTickets = async (ticketNo) =>{
        const defaultTicketValue = 100;
        const total = ticketNo * defaultTicketValue
        setTotalAmount(total);
        setNoOfTickets(ticketNo);
        setAmount(total)
    }
    if(redirect){
        return <Navigate to={'/play'} />
    }
     return (
         <Wrapper pageTitle={"Nouveau Billet de Tirage"}>
            <InnerNav createLink={'/playCreate'} listLink={'/plays'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Nombre de billets </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Nombre de billets"
                        type="number"
                        pattern="[0-9]*"
                        onChange = {e => manageTickets(e.target.value)} />
                    </label>
                   
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Montant </span>
                        <input readOnly
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Montant"
                        value={totalAmount}
                         />
                    </label>

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Jouer au Tirage</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default PlayCreate;